module.exports = __webpack_public_path__ + "static/media/nft7.6709b7a6.jpg";